// store/store.ts
import { configureStore } from "@reduxjs/toolkit";
import contentReducer from "./contentSlice";
import messageReducer from "./messageSlice";

const store = configureStore({
  reducer: {
    content: contentReducer,
    message: messageReducer,
  },
});

// Export RootState type
export type RootState = ReturnType<typeof store.getState>;

export default store;
